import { IItemSale } from "@/pages/point-of-sale/models/sale.model";

export function groupItemsByProductAndContainer(items: IItemSale[]): IItemSale[] {
  const grouped: Record<string, IItemSale> = {};

  for (const item of items) {
    const key = `${item.productId}-${item.containerType.id}`;

    // Filtrar lots con cantidad > 0
    const filteredLots = item.lots.filter(lot => lot.quantity > 0);

    if (filteredLots.length === 0) continue; // si no hay lots válidos, omitimos el item

    if (!grouped[key]) {
      grouped[key] = { ...item, lots: [...filteredLots] };
    } else {
      grouped[key].lots.push(...filteredLots);
      grouped[key].quantity += item.quantity;
      grouped[key].totalPrice += item.totalPrice;
    }
  }

  return Object.values(grouped);
}
